import { render } from "./EmailDraft.vue?vue&type=template&id=07e6309a&scoped=true"
import script from "./EmailDraft.vue?vue&type=script&lang=js"
export * from "./EmailDraft.vue?vue&type=script&lang=js"

import "./EmailDraft.vue?vue&type=style&index=0&id=07e6309a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e6309a"]])

export default __exports__